export default __webpack_public_path__ + "static/media/img-join-page.a6a5d7ca.png";